// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3hqaN","footer":"ModalError_footer__YVMSU"};